import { IProductResponse } from '@pages/PageProducts/tariffsAndServicesProductTypes';

export const filterAvailableProducts = (props: IProductResponse): IProductResponse => {
    const { campaignTariffs, campaignServices, tariffs, services } = props;

    const availableCampaignTariffs = campaignTariffs?.filter(tariff => tariff.isAvailable) || [];
    const availableCampaignServices = campaignServices?.filter(service => service.isAvailable) || [];
    const availableTariffs = tariffs.filter(tariff => tariff.isAvailable);
    const availableServices = services.filter(service => service.isAvailable);

    return {
        campaignTariffs:  [...availableCampaignTariffs],
        campaignServices:  [...availableCampaignServices],
        tariffs: [...availableTariffs],
        services: [...availableServices],
    }
};
